import { render } from "./product-list-skeleton.vue?vue&type=template&id=2f64fdfa"
import script from "./product-list-skeleton.vue?vue&type=script&lang=js"
export * from "./product-list-skeleton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__